import { StandardButton } from '@/components/buttons';
import { WorkflowFooter } from '@/components/workflow/workflow-footer';
import { Button, Flex, Text } from '@mantine/core';
import { Icon123, IconBarcode, IconInfoCircle } from '@tabler/icons-react';
import { AnimatePresence, motion } from 'motion/react';
import { useMemo } from 'react';
import { useBaleProcessedContext } from './hook';

export const BaleProcessedFooter = () => {
	const { page, setPage, showManualCodeEntry, setShowManualCodeEntry, scannedBales, submitBales } =
		useBaleProcessedContext();

	const footerContent = useMemo(() => {
		switch (page) {
			case 'SCAN':
				return {
					actions: (
						<motion.div
							layout
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
							transition={{ duration: 0.3 }}
							style={{ width: '100%', display: 'flex', justifyContent: 'center', gap: '12px' }}
						>
							<Button
								size="lg"
								variant="filled"
								c="white"
								bg="grey"
								fullWidth
								style={{ fontSize: 18 }}
								onClick={() => setShowManualCodeEntry(true)}
								leftSection={<Icon123 size={16} />}
							>
								Enter Code
							</Button>
							{scannedBales.length > 0 && (
								<Button
									leftSection={<IconBarcode size={16} />}
									onClick={() => setPage('CONFIRM')}
									size="lg"
									variant="filled"
									fullWidth
									style={{ fontSize: 18 }}
								>
									Submit
								</Button>
							)}
						</motion.div>
					),
					secondary: scannedBales.length > 0 && (
						<Flex pb="lg" pt="md" px="lg" align="center" gap="xs">
							<IconInfoCircle size={16} />
							<Text size="sm">
								You have scanned {scannedBales.length} bale{scannedBales.length > 1 ? 's' : ''}.
							</Text>
						</Flex>
					),
				};
			case 'CONFIRM':
				return {
					actions: <StandardButton onClick={submitBales}>Submit</StandardButton>,
				};
		}
	}, [page, scannedBales.length, submitBales, setShowManualCodeEntry, setPage]);

	const shouldHideFooter = useMemo(() => {
		if (showManualCodeEntry) {
			return true;
		}
		return false;
	}, [showManualCodeEntry]);

	return (
		<AnimatePresence initial={false}>
			{!shouldHideFooter && (
				<motion.div
					initial={{ y: 150 }}
					animate={{
						y: 0,
						transition: {
							type: 'spring',
							damping: 25,
							stiffness: 300,
							mass: 0.8,
							delay: 0.1,
						},
					}}
					exit={{
						y: 150,
						transition: {
							type: 'spring',
							damping: 30,
							stiffness: 400,
							mass: 0.6,
							duration: 0.25,
						},
					}}
					style={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }}
				>
					<WorkflowFooter secondaryContent={footerContent.secondary}>
						{footerContent.actions}
					</WorkflowFooter>
				</motion.div>
			)}
		</AnimatePresence>
	);
};
